import './styles.css'
// assets
import { ReactComponent as PAMIcon } from '../../../../../assets/imgs/recruting/pam-health-logo-white.svg'

const RecruitingQuote = () => (
  <div className='box recruiting-quote-mobile-container'>
    <div className='recruiting-quote-outer-container'>
      <div className='recruiting-quote-inner-container'>
        <div className='recruiting-quote-text-container'>
          <p className='recruiting-quote-text'>
            “With over 10,000 employees across the U.S., Pod gives us
            exceptional visibility into our talent, ensuring the right resources
            are in the right places to deliver high-quality care to our
            patients.”
          </p>
          <p className='recruiting-quote-feedback-name'>Nicholas Fazzolari</p>
        </div>

        <div className='recruiting-quote-icon-container'>
          <PAMIcon />
        </div>
      </div>
    </div>
  </div>
)

export default RecruitingQuote
